/*
 * Halkhouse device picker
 *
 * Every product for every generation is rendered once, up front, and filtering is
 * pure show/hide — no fetch, no page load. The catalogue is small enough that this
 * is faster than the Section Rendering API and keeps the interaction instant.
 *
 * Selecting a generation shows all of its products. Selecting a sub-model narrows
 * to that collection. Touch devices get an explicit open/close on the popover,
 * because :hover never resolves there.
 */
(function () {
  "use strict";

  var TOUCH = window.matchMedia("(hover: none)").matches;

  function init(root) {
    if (root.dataset.hhReady === "1") return;
    root.dataset.hhReady = "1";

    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-hh-card]"));
    var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-hh-group]:not([data-hh-collection])"));
    var subs = Array.prototype.slice.call(root.querySelectorAll("[data-hh-collection]"));
    var chip = root.querySelector("[data-hh-chip]");
    var chipLabel = root.querySelector("[data-hh-chip-label]");
    var clearBtn = root.querySelector("[data-hh-clear]");
    var live = root.querySelector("[data-hh-live]");
    var empty = root.querySelector("[data-hh-empty]");

    var state = { group: null, collection: null };

    var firstTab = tabs[0];
    if (firstTab) state.group = firstTab.dataset.hhGroup;

    function apply() {
      var shown = 0;

      cards.forEach(function (card) {
        var inGroup = card.dataset.hhGroup === state.group;
        var match = inGroup;

        if (match && state.collection) {
          var list = (card.dataset.hhCollections || "").split(/\s+/);
          match = list.indexOf(state.collection) !== -1;
        }

        card.hidden = !match;
        if (match) shown++;
      });

      // tab pressed state
      tabs.forEach(function (t) {
        var on = t.dataset.hhGroup === state.group;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-pressed", on ? "true" : "false");
      });

      // sub-model active state
      subs.forEach(function (b) {
        b.classList.toggle(
          "is-active",
          !!state.collection &&
            b.dataset.hhCollection === state.collection &&
            b.dataset.hhGroup === state.group
        );
      });

      // chip reflects only the narrower sub-model filter
      if (chip) {
        if (state.collection) {
          var active = subs.filter(function (b) {
            return b.dataset.hhCollection === state.collection && b.dataset.hhGroup === state.group;
          })[0];
          var span = active && active.querySelector("span");
          chipLabel.textContent = span ? span.textContent.trim() : state.collection;
          chip.hidden = false;
        } else {
          chip.hidden = true;
        }
      }

      if (empty) empty.hidden = shown !== 0;
      if (live) live.textContent = shown + " ürün gösteriliyor";
    }

    function closeAllPops() {
      root.querySelectorAll(".hh-dev__tabitem.is-open").forEach(function (li) {
        li.classList.remove("is-open");
        var t = li.querySelector(".hh-dev__tab");
        if (t) t.setAttribute("aria-expanded", "false");
      });
    }

    tabs.forEach(function (tab) {
      tab.setAttribute("aria-expanded", "false");

      tab.addEventListener("click", function () {
        var item = tab.closest(".hh-dev__tabitem");
        var hasSubs = item && item.querySelector("[data-hh-pop]");

        // On touch the sub-models expand in flow beneath the tab, so the tab acts
        // as a disclosure: tapping it toggles the list open and closed.
        if (TOUCH && hasSubs) {
          var willOpen = !item.classList.contains("is-open");
          closeAllPops();
          item.classList.toggle("is-open", willOpen);
          tab.setAttribute("aria-expanded", willOpen ? "true" : "false");
        }

        state.group = tab.dataset.hhGroup;
        state.collection = null;
        apply();
      });
    });

    subs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.group = btn.dataset.hhGroup;
        // Tapping the active sub-model again clears it
        state.collection = state.collection === btn.dataset.hhCollection ? null : btn.dataset.hhCollection;
        closeAllPops();

        // Once a model is chosen the panel has done its job — get it out of the
        // way so the filtered grid underneath is actually visible. On desktop
        // dropping .is-open is not enough, because :hover and :focus-within
        // still hold the panel open; .is-dismissed overrides both, and the
        // blur() drops the focus that would otherwise keep it up.
        var item = btn.closest(".hh-dev__tabitem");
        if (item) item.classList.add("is-dismissed");
        btn.blur();

        apply();
      });
    });

    // Let the panel come back: moving the pointer away and returning, or tabbing
    // back in, should reopen it normally.
    root.querySelectorAll(".hh-dev__tabitem").forEach(function (item) {
      item.addEventListener("mouseleave", function () {
        item.classList.remove("is-dismissed");
      });
      item.addEventListener("focusin", function () {
        item.classList.remove("is-dismissed");
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener("click", function () {
        state.collection = null;
        apply();
      });
    }

    root.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closeAllPops();
        var open = root.querySelector(".hh-dev__tab:focus, .hh-dev__sub-btn:focus");
        if (open) open.blur();
      }
    });

    if (TOUCH) {
      document.addEventListener("click", function (e) {
        if (!root.contains(e.target)) closeAllPops();
      });
    }

    apply();
  }

  function boot() {
    document.querySelectorAll("[data-hh-device-picker]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Theme editor re-renders sections without a full page load
  document.addEventListener("shopify:section:load", boot);
})();
